import type { ButtonHTMLAttributes, ReactNode } from "react";
import styles from "./ModelCard.module.css";
import { cx } from "../cx";
import { IconBrick, IconCheckmarkLine } from "../icons/Icon";

export type ModelCardProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children"> & {
  name: ReactNode;
  summary: ReactNode;
  cost: number;
  icon?: ReactNode;
  /** "기본" | "추천" 등 */
  tag?: ReactNode;
  selected?: boolean;
};

/** 대화 모델 행 (Figma ModelRow 488:11788). 아이콘 · 이름+태그/요약 · 단가 · radio. 노크 30 / 돌파 60. */
export function ModelCard({ name, summary, cost, icon, tag, selected = false, className, ...rest }: ModelCardProps) {
  return (
    <button type="button" role="radio" aria-checked={selected} className={cx(styles.root, selected && styles.selected, className)} {...rest}>
      {icon && <span className={styles.icon}>{icon}</span>}
      <span className={styles.text}>
        <span className={styles.title}>
          <span className={styles.name}>{name}</span>
          {tag && <span className={styles.tag}>{tag}</span>}
        </span>
        <span className={styles.summary}>{summary}</span>
      </span>
      <span className={styles.cost}>
        <IconBrick size={14} />
        <b>{cost}</b>
      </span>
      <span className={cx(styles.radio, selected && styles.radioOn)}>{selected && <IconCheckmarkLine size={14} />}</span>
    </button>
  );
}
